import { render } from "./Form.vue?vue&type=template&id=2b5dacd6&ts=true&lang=pug"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=2b5dacd6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__